import {
  COOKIE_PATH,
  COOKIE_SESSION_ID_KEY,
  newBrowserSessionId,
  SESSION_STORAGE_KEY,
} from "./browserSessionId";

function readFromCookie() {
  if (globalThis.document === null || globalThis.document === undefined)
    return undefined;
  return document.cookie
    .split("; ")
    .find((row) => row.startsWith(COOKIE_SESSION_ID_KEY))
    ?.split("=")[1];
}

function writeToCookie(sessionId: string) {
  if (globalThis.document === null || globalThis.document === undefined) return;
  document.cookie = `${COOKIE_SESSION_ID_KEY}=${sessionId}; path=${COOKIE_PATH}`;
}

// Return the value that is used to populate `browsingSessionId` in hopper-web-bff.
// It is used by the fraud team to track the user.
export const getBrowserSessionId = () => {
  const sessionId =
    readFromCookie() ??
    sessionStorage.getItem(SESSION_STORAGE_KEY) ??
    newBrowserSessionId();
  sessionStorage.setItem(SESSION_STORAGE_KEY, sessionId);
  writeToCookie(sessionId);

  return sessionId;
};
